// Этот файл генерируется автоматически, его не следует редактировать вручную
import deleteAccount from '@/widgets/deleteAccount.js';
import eventButton from '@/widgets/eventButton.js';
import filterItem from '@/widgets/filterItem.js';
import form from '@/widgets/form.js';
import headerSticky from '@/widgets/headerSticky.js';
import createVueWidget from '@/core/createVueWidget.js';
import mapBlock from '@/widgets/mapBlock.vue';
import mapBlockContact from '@/widgets/mapBlockContact.js';
import mobileMenu from '@/widgets/mobileMenu.js';
import mobileMenuButton from '@/widgets/mobileMenuButton.js';
import passwordField from '@/widgets/passwordField.vue';
import scrollTop from '@/widgets/scrollTop.js';
import sliderMainJoin from '@/widgets/sliderMainJoin.js';
import sliderMemberWhat from '@/widgets/sliderMemberWhat.js';
import sliderResources from '@/widgets/sliderResources.js';
import videoBlock from '@/widgets/videoBlock.js';

export default {
  'collapse': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/collapse.js'),
  'deleteAccount': async () => { return { default: deleteAccount }; },
  'eventButton': async () => { return { default: eventButton }; },
  'filterItem': async () => { return { default: filterItem }; },
  'form': async () => { return { default: form }; },
  'headerSticky': async () => { return { default: headerSticky }; },
  'mapBlock': async () => { return { default: (element, data) => createVueWidget(mapBlock, element, data) }; },
  'mapBlockContact': async () => { return { default: mapBlockContact }; },
  'mobileMenu': async () => { return { default: mobileMenu }; },
  'mobileMenuButton': async () => { return { default: mobileMenuButton }; },
  'passwordField': async () => { return { default: (element, data) => createVueWidget(passwordField, element, data) }; },
  'scrollTop': async () => { return { default: scrollTop }; },
  'searchBlock': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/searchBlock.js'),
  'searchBlockPage': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/searchBlockPage.js'),
  'sliderMainJoin': async () => { return { default: sliderMainJoin }; },
  'sliderMemberWhat': async () => { return { default: sliderMemberWhat }; },
  'sliderResources': async () => { return { default: sliderResources }; },
  'telephoneMask': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/telephoneMask.js'),
  'videoBlock': async () => { return { default: videoBlock }; }
};
